module.exports = __webpack_public_path__ + "img/disdrometro.446b4bde.webp";